import React from 'react';
import { Box, Typography } from '@mui/material';

const AboutSection2 = () => (
    <Box my={3}>
        <Typography variant='subtitle1' textAlign='center' mb={2}>
            Our Mission
        </Typography>
        <Typography variant='body1' mb={1}>
            KwadHub was created to help drone pilots mark and save their favorite flying spots. Users can choose to keep
            their spots private or share them with the community, anonymously if preferred.
        </Typography>
        <Typography variant='body1' mb={1}>
            As a growing community, we believe in the power of sharing. By contributing your favorite spots, you help
            create a valuable resource for others, transforming KwadHub from a simple map into a thriving community.
        </Typography>
        <Typography variant='body1'>
            Join us in making drone flying safer, more accessible, and more connected for everyone.
        </Typography>
    </Box>
);

export default AboutSection2;
